var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClear = function SvgClear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.65,
    stroke: "#2F353B",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4596 14.5404C15.7135 14.7942 15.7135 15.2058 15.4596 15.4596C15.2058 15.7135 14.7942 15.7135 14.5404 15.4596L15.4596 14.5404ZM12 12L11.5404 11.5404C11.7942 11.2865 12.2058 11.2865 12.4596 11.5404L12 12ZM9.45962 15.4596C9.20578 15.7135 8.79422 15.7135 8.54038 15.4596C8.28654 15.2058 8.28654 14.7942 8.54038 14.5404L9.45962 15.4596ZM14.5404 15.4596L11.5404 12.4596L12.4596 11.5404L15.4596 14.5404L14.5404 15.4596ZM12.4596 12.4596L9.45962 15.4596L8.54038 14.5404L11.5404 11.5404L12.4596 12.4596Z",
    fill: "#0070E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4596 9.45962C15.7135 9.20578 15.7135 8.79422 15.4596 8.54038C15.2058 8.28654 14.7942 8.28654 14.5404 8.54038L15.4596 9.45962ZM12 12L11.5404 12.4596C11.7942 12.7135 12.2058 12.7135 12.4596 12.4596L12 12ZM9.45962 8.54038C9.20578 8.28654 8.79422 8.28654 8.54038 8.54038C8.28654 8.79422 8.28654 9.20578 8.54038 9.45962L9.45962 8.54038ZM14.5404 8.54038L11.5404 11.5404L12.4596 12.4596L15.4596 9.45962L14.5404 8.54038ZM12.4596 11.5404L9.45962 8.54038L8.54038 9.45962L11.5404 12.4596L12.4596 11.5404Z",
    fill: "#0070E0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear.70c85ca3.svg";
export { ForwardRef as ReactComponent };